import { lazy } from 'react';
/** Открывает карточку адреса исполнителя */
export const ExecutorAddressDetailsPageAsync = lazy(() => import('./ExecutorAddressDetails/ExecutorAddressDetailsPage'));